import { apiFetch } from '@/api'
import { Depreciation } from '@/interfaces'

export const fetchAllDepreciations = async (): Promise<Depreciation> =>
  (await apiFetch('/depreciations', { method: 'GET' })).data
